import { Container, makeStyles, Paper } from "@material-ui/core";

import { Motivation } from "./Motivation";
import { AllLevels } from "./AllLevels";
import { GardenerDocument } from "../../gardener/gardener.model";

const useStyles = makeStyles(theme => ({
    card: {
        overflow: "hidden",
        padding: "24px",

        [theme.breakpoints.down(500)]: {
            padding: "24px 16px",
        },

        "& > *": {
            marginBottom: "24px",

            "&:last-child": {
                marginBottom: 0,
            },
        },
    },
    header: {
        "& > h3": {
            fontSize: "16px",
            fontWeight: 600,
            color: "#4A4A4A",
            textAlign: "center",

            margin: 0,
        },
    },
    paragraph: {
        fontSize: "16px",
        fontWeight: 400,
        color: "#4A4A4A",

        [theme.breakpoints.down(1100)]: {
            textAlign: "center",
        },
    },
    levels: {
    },
    divider: {
        backgroundColor: "#000000",
        opacity: 0.2,
        height: "1px",
    },
    motivation: {
        fontSize: "14px",
        fontWeight: 400,
        color: "#4A4A4A",
        textAlign: "center",
    },
}));

interface YourLevelFullCardProps {
    gardener: GardenerDocument;
}

export const YourLevelFullCard = (props: YourLevelFullCardProps) => {
    const classes = useStyles();
    const { gardener } = props;

    return (
        <Container maxWidth="md" disableGutters>
            <Paper className={classes.card}>

                <div className={classes.header}>
                    <h3>Dit niveau</h3>
                </div>

                <div className={classes.paragraph}>
                    Dit niveau kommer an på hvor mange af de opgaver, du siger ja tak til, der bliver løst. Ved at løse flere opgaver, stiger du i niveau og opnår nye fordele.
                </div>

                <AllLevels cooperationLevel={gardener.status === "active" ? gardener.cooperation.level : null} />

                {gardener.status === "active" ? (
                    <>
                        <div className={classes.divider} />
        
                        <Motivation cooperation={gardener.cooperation} />
                    </>
                ) : null}

            </Paper>
        </Container>
    );
};
